import { actionCreators } from '../reducers/login/loginReducer'
import { actionCreators as gradPlannerActions } from '../reducers/gradPlanner/gradPlannerReducer'
export default (timeToLogoutInMinutes = 10) => {
  // timeToLogoutInMinutes = 1
  let timer = null
  console.log(timeToLogoutInMinutes, 'minutes to timeout')
  const timeToLogoutInMS = timeToLogoutInMinutes * 60000
  // const timeToLogoutInMS = 0.1 * 60000 // for debugging
  const logoutMiddleware = store => next => action => {
    const initTimout = () => {
      window.clearTimeout(timer)
      // console.log('resetting timeout', Date.now(), action.type)
      timer = window.setTimeout(() => {
        console.log('user has been inactive', Date.now())
        if (store.getState().login.authorized) {
          store.dispatch(actionCreators.reset())
          store.dispatch(gradPlannerActions.reset())
          window.alert('You have been logged out, due to timeout (10 minutes)')
        }
        initTimout()
      }, timeToLogoutInMS)
    }
    initTimout()
    next(action)
  }
  return logoutMiddleware
}



// WEBPACK FOOTER //
// ./src/redux/middleware/timeout.js